import { css } from 'styled-components';

// In case user enters a long text such as URL
// or the phase that connected with `-`, `_` ...
// The long word should be forced to break into new line.
const userCustomContent = css`
  word-break: break-word;
`;

export default userCustomContent;
